var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCashLine = function SvgCashLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.5 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m6.754-8.998h-13.5a.75.75 0 0 0-.75.75v10.5c0 .414.335.75.75.75h13.5a.75.75 0 0 0 .75-.75v-10.5a.75.75 0 0 0-.75-.75m-12.75 8.733v-5.47a2.63 2.63 0 0 0 1.762-1.763h8.469a2.63 2.63 0 0 0 1.769 1.765v5.466a2.63 2.63 0 0 0-1.77 1.769H8.266a2.63 2.63 0 0 0-1.763-1.767Z"
  })));
};
export default SvgCashLine;